import axios from "axios";
import { HeaderRequest as getHeaders } from "../components/Request/Header/Header";
import { HeaderRequestFull as getHeadersFull } from "../components/Request/Header/Header";
import https from "https";
import { API_CODE_SUCCESS } from "../constants/CommonConstant";
import { storeData } from "./GlobalHelper";
//import urljoin from "url-join";
const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
  requestCert: false,
});

const isMock = false;

// Please use file name as url + _response.json
const get = async (url, config) => {
  storeData("api_error", {});
  // Case use manual mock
  if (url.endsWith(".json")) {
    return await axios.get(url);
  }
  const headers = await getHeaders();
  const mockPath = url
    .split("/")
  [url.split("/").length - 1].replace(/[-]/g, "_")
    .split("?")[0];
  if (isMock) return await axios.get(`/data/mock/${mockPath}_response.json`);
  return await axios
    .get(url, {
      ...config,
      httpsAgent,
      headers: config?.header || config?.headers || headers,
    })
    .then((res) => {
      if (res.data?.api_status?.api_code !== API_CODE_SUCCESS) {
        let urlSplit = url.split("/");
        let service = url ? urlSplit[urlSplit.length - 1] : "";
        storeData("api_error", {
          url,
          service: service,
          status: res.data?.api_status?.api_code || res?.status,
          api_status: res.data?.api_status,
        });
      }
      return res;
    })
    .catch((error) => {
      let urlSplit = url.split("/");
      let service = url ? urlSplit[urlSplit.length - 1] : "";
      storeData("api_error", {
        url,
        service: service,
        status: error?.response?.status,
        message: error?.message,
        data: error?.response?.data,
      });
      return error;
    });
};

// Please use file name as url + _response.json
const post = async (url, body, config) => {
  storeData("api_error", {});
  //const headers = await getHeadersFull();
  const mockPath = url
    .split("/")
  [url.split("/").length - 1].replace(/[-]/g, "_");
  if (isMock) return await axios.get(`/data/mock/${mockPath}_response.json`);
  return await axios
    .post(url, body, {
      ...config,
      // httpsAgent,
      // headers: config?.header || config?.headers || headers,
    })
    .then((res) => {
      if (res.data?.api_status?.api_code !== API_CODE_SUCCESS) {
        let urlSplit = url.split("/");
        let service = url ? urlSplit[urlSplit.length - 1] : "";
        storeData("api_error", {
          url,
          service: service,
          status: res?.status,
          api_status: res.data?.api_status,
        });
      }
      return res;
    })
    .catch((error) => {
      let urlSplit = url.split("/");
      let service = url ? urlSplit[urlSplit.length - 1] : "";
      storeData("api_error", {
        url,
        service: service,
        status: error?.response?.status,
        message: error?.message,
        data: error?.response?.data,
      });
      return error;
    });
};
const remove = async (url, body, config) => {
  storeData("api_error", {});
  const headers = await getHeaders();
  const mockPath = url
    .split("/")
    [url.split("/").length - 1].replace(/[-]/g, "_")
    .split("?")[0];

  if (isMock) return await axios.get(`/data/mock/${mockPath}_response.json`);

  return await axios
    .delete(url, {
      ...config,
      data: body, // ✅ ใส่ JSON body ที่นี่
      httpsAgent,
      headers: {
        "Content-Type": "application/json", // ✅ ระบุว่าเป็น JSON
      },
    })
    .then((res) => {
      if (res.data?.api_status?.api_code !== API_CODE_SUCCESS) {
        const urlSplit = url.split("/");
        const service = urlSplit[urlSplit.length - 1] || "";
        storeData("api_error", {
          url,
          service,
          status: res?.status,
          api_status: res.data?.api_status,
        });
      }
      return res;
    })
    .catch((error) => {
      const urlSplit = url.split("/");
      const service = urlSplit[urlSplit.length - 1] || "";
      storeData("api_error", {
        url,
        service,
        status: error?.response?.status,
        message: error?.message,
        data: error?.response?.data,
      });
      return error;
    });
};



export default { get, post, delete: remove };
